import React from 'react';
export function Footer() {
  return <footer className="bg-navy py-12 px-6 border-t border-white/10 text-center" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <p className="font-serif text-xl text-white/80 mb-4" data-id="element-24">
          MÉTODO 7-D MORNINGS
        </p>
        <p className="text-white/40 text-sm" data-id="element-25">
          © {new Date().getFullYear()} El Despertar de la Gracia. Todos los
          derechos reservados.
        </p>
        <p className="text-white/30 text-xs mt-6 max-w-2xl mx-auto leading-relaxed" data-id="element-26">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener sobre una
          condición médica.
        </p>
      </div>
    </footer>;
}